/* unplugin-vue-components disabled */import { ElContainer as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/container/style/css';
import { ElMain as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/main/style/css';
import { ElHeader as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/header/style/css';
import { ElAside as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/aside/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6fbe231d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "height100"
};
const _hoisted_2 = {
  key: 0,
  class: "notice"
};
const _hoisted_3 = {
  class: "flex height100"
};
const _hoisted_4 = {
  class: "fix-bar"
};
import Sidebar from './modules/sidebar.vue';
import Topbar from './modules/topbar.vue';
import Menus from './modules/menus.vue';
import DataCenterQrcode from './modules/dataCenterQrcode.vue';
import { apiGetCommentList, apiGetCommentTags, apiGetCommentCount, apiUpdateComment, apiSaveComment, apiDeleteComment } from '@/api/app';
import Comment from '@ultra/share/components/Comment/index.vue';
import { useAppStore } from '@/store/modules/app';
import { useGlobalStateStore } from '@/store/modules/globalState';
import { useUserStore } from '@/store/modules/user';
import { storeToRefs } from 'pinia';
import { UseGlobalConfig } from '@/utils/hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'defaultLayout',
  setup(__props) {
    const appStore = useAppStore();
    const {
      isShowNotice
    } = storeToRefs(useGlobalStateStore());
    const {
      getNotice
    } = useGlobalStateStore();
    const route = useRoute();
    const router = useRouter();
    const userStore = useUserStore();
    const {
      $has
    } = UseGlobalConfig();
    const isOperate = computed(() => {
      return route.path.includes('/module-app');
    });
    const menus = computed(() => {
      if (!isOperate) {
        return [];
      }
      const matched = route.matched;
      if (matched.length > 1) {
        const matchedRoute = matched[1];
        if (matchedRoute.path === '/pack' && appStore.gameType === 'miniapp') {
          return matchedRoute.children.filter(item => ['MiniSdk'].includes(item.name));
        }
        return matchedRoute.children.filter(item => item.name !== 'MiniSdk');
      }
      return [];
    });
    watch(() => appStore.gameType, val => {
      if (route.path.includes('/pack') && router.hasRoute('SDK') && router.hasRoute('MiniSdk')) {
        if (val === 'miniapp') {
          router.replace({
            name: 'MiniSdk'
          });
        } else {
          router.replace({
            name: 'SDK'
          });
        }
      }
    }, {
      immediate: true
    });
    // 是否允许评论
    const allowComment = $has('comment');
    watch(() => appStore.gameInfo, val => {
      if (val) {
        getNotice(val.Id);
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_aside = __unplugin_components_0;
      const _component_el_header = __unplugin_components_1;
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = __unplugin_components_2;
      const _component_el_container = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "height100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: "80px",
          class: "height100"
        }, {
          default: _withCtx(() => [_createVNode(Sidebar)]),
          _: 1
        }), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_unref(isShowNotice) ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 实名认证中宣部参数存在失效风险，请及时替换。 ")) : _createCommentVNode("", true), _createVNode(_component_el_header, null, {
            default: _withCtx(() => [_createVNode(Topbar)]),
            _: 1
          }), _createVNode(_component_el_main, {
            class: "main"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [!_unref(isOperate) ? (_openBlock(), _createBlock(Menus, {
              key: 0,
              menus: _unref(menus),
              class: "shrink-0"
            }, null, 8, ["menus"])) : _createCommentVNode("", true), _createElementVNode("div", {
              class: _normalizeClass([_unref(menus).length > 0 ? 'has-menus' : '', 'flex-1', 'width100'])
            }, [_unref(route).meta.keepAlive ? (_openBlock(), _createBlock(_KeepAlive, {
              key: 0
            }, [_createVNode(_component_router_view)], 1024)) : (_openBlock(), _createBlock(_component_router_view, {
              key: 1
            }))], 2)])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(DataCenterQrcode, {
        class: "marginB10"
      }, null, 512), [[_vShow, _unref(route).name === 'DataCenter']]), _createVNode(Comment, {
        commentKey: _unref(appStore).commentKey,
        uid: _unref(userStore).uid,
        allowComment: _unref(allowComment),
        apis: {
          getList: _unref(apiGetCommentList),
          getTags: _unref(apiGetCommentTags),
          getCount: _unref(apiGetCommentCount),
          update: _unref(apiUpdateComment),
          save: _unref(apiSaveComment),
          del: _unref(apiDeleteComment)
        }
      }, null, 8, ["commentKey", "uid", "allowComment", "apis"])])]);
    };
  }
});